import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import axios from 'axios';
import {
  BetaBackground,
  BetaHero,
  BetaPerks,
  MemoryDifferentiator,
  BetaForm,
  BetaSuccess
} from '@/components/beta/BetaSections';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BetaPage = () => {
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const cards = document.querySelectorAll('.memory-card-beta');
    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!firstName.trim() || !email.trim()) {
      toast.error('Please enter your name and email');
      return;
    }
    if (!email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/waitlist/join`, {
        first_name: firstName.trim(),
        email: email.trim().toLowerCase(),
        reason: reason || null,
      });
      setSubmitted(true);
      toast.success('You\'re on the list!');
    } catch (error) {
      if (error.response?.status === 409) {
        toast.error('This email is already on the waitlist');
      } else {
        toast.error('Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden" style={{ backgroundColor: '#FBF9F6' }}>
      <BetaBackground />
      <main className="relative z-10 min-h-screen flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-lg">
          {!submitted ? (
            <>
              <BetaHero />
              <BetaPerks />
              <MemoryDifferentiator />
              <BetaForm
                firstName={firstName}
                setFirstName={setFirstName}
                email={email}
                setEmail={setEmail}
                reason={reason}
                setReason={setReason}
                loading={loading}
                onSubmit={handleSubmit}
              />
            </>
          ) : (
            <BetaSuccess firstName={firstName} />
          )}
        </div>
      </main>
    </div>
  );
};
